import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'
export default async function (data) {
	const node = data.node;
	const title = node.title;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme)
	const ex3= await getThemePic(data?.customTheme, 'ex-3')

	return {
		"id": id,
		"elements": [
			{
				"type": "text",
				"id": "7CejWMKt1L",
				"width": 610,
				"height": 82.21875,
				"left": 195,
				"top": 152.19,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333",
				"content": `<p style=\"text-align: center;\"><span style=\"font-size: 61.22px;\"><span style=\"font-family: Arial;\">${title}</span></span></p>`,
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "text",
				"id": "B5Nthd3VYs",
				"width": 184.43,
				"height": 40.40625,
				"left": 295.64,
				"top": 281.56,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333",
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 20.41px;font-family: Arial;\">汇报人：ChatGpt</span></p>",
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "text",
				"id": "ya_zKObDIi",
				"width": 296.48,
				"height": 40.40625,
				"left": 452.32,
				"top": 281.56,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333",
				"content": "<p style=\"text-align: center;\"><span style=\"font-size: 20.41px;font-family: Arial;\">汇报时间：</span><span style=\"font-size: 20.41px;font-family: Arial;\">202X.X.X</span></p>",
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "image",
				"id": "fxhBwtGqPZ",
				"src": ex3,
				"width": 263.57354159271097,
				"height": 50.42276447860557,
				"left": 368.2132292036445,
				"top": 349.374626362715,
				"fixedRatio": true,
				"rotate": 0
			}
		],
		background
	};

}